import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { NotificationTelegramChannelInterface } from '@shared/api';
import { environment } from '@shared/environments';
import { map, Observable } from 'rxjs';
import { CustomEntityCollectionBaseService } from '../../../entity-collection-base.class';
import { EntityTypeEnum } from '../../../entity.interface';

@Injectable({ providedIn: 'root' })
export class TelegramChannelsService extends CustomEntityCollectionBaseService<NotificationTelegramChannelInterface> {
  private readonly http = inject(HttpClient);

  constructor(elementsFactory: EntityCollectionServiceElementsFactory) {
    super(EntityTypeEnum.TelegramChannel, elementsFactory);
  }

  getTelegramCode(): Observable<string> {
    return this.http
      .post<{
        id: number;
        code: string;
      }>(
        `${environment.apiHost}/notification/channel/telegram/createVerificationCode`,
        {},
      )
      .pipe(map((response: { id: number; code: string }) => response.code));
  }
}
